export const footer_loader = async function(scripts) {
  var jquery_hold = false;
  if (!scripts) return;

  var existing = {
    scripts: document.getElementById('dynamic-scripts').children,
    vars: document.getElementById('dynamic-vars').children,
    styles: document.getElementById('dynamic-styles').children,
  }

  var wrapper = document.createElement('div');
  var new_element;
  var from_server = {
    scripts: [],
    vars: [],
    styles: [],
  }

  var to_load = {
    scripts: [],
    vars: [],
    styles: [],
  }

  var datepicker = document.getElementById('ui-datepicker-div');
  if (datepicker !== null) {
    datepicker.parentNode.removeChild(datepicker);
  }

  scripts.forEach(function(item, key) {
    wrapper.innerHTML = item;
    new_element = wrapper.firstChild;
    if (new_element.tagName.toLowerCase() != "script") {
      from_server.styles.push(new_element);
    } else {
      if (new_element.src != '') {
        from_server.scripts.push(new_element);
      } else {
        from_server.vars.push(new_element);
      }
    }
  });

  var add = true;
  for (var type in from_server) {
    if (from_server[type].length == 0) continue;
    for (var element_id in from_server[type]) {
      add = true;
      if (existing[type].length > 0) {
        for (let existing_element of existing[type]) {
          if (existing_element.isEqualNode(from_server[type][element_id])) {
            add = false;
            break;
          }
        }
      }
      if (add === true) {
        to_load[type].push(from_server[type][element_id]);
      }

    }
  }

  loadStyles()
  loadVars();
  await loadScripts();

  function loadStyles() {
    if (to_load.styles.length < 1) return;
    for (var element of to_load.styles) {
      document.getElementById('dynamic-styles').appendChild(element);
    }
  }

  function loadVars() {
    if (to_load.vars.length < 1) return;
    for (var element of to_load.vars) {
      let js = document.createElement(element.tagName);
      js.type = 'text/javascript';
      js.text = element.text;
      document.getElementById('dynamic-vars').appendChild(js);
    }
  }

  async function loadScripts() {
    let script = to_load.scripts.shift();
    if (!script) {
      if (window.jQuery) jQuery.holdReady(false);
      initFrm();
      return;
    }
    let js = document.createElement(script.tagName);
    if (window.jQuery && jquery_hold === false) {
      jQuery.holdReady(true);
      jquery_hold = true;
    } 
    js.type = 'text/javascript';
    js.src = script.src;

    js.onload = await function(event) {
      loadScripts();
    };
    document.getElementById('dynamic-scripts').appendChild(js);
  }


  function initFrm() {
    document.getElementById('app').arrive('.frm_forms', function() {
      if (typeof frmProForm === 'object' && frmProForm !== null) frmProForm.init();
      document.getElementById('app').unbindArrive('.frm_forms');
    });
  }

}